<template>
  <section>
    <el-dialog :visible.sync="dialogVisible_approve">
      <Approve v-if="dialogVisible_approve" @approve_submit="approve_submit" :SP_IF="SP_IF" :ApproveList="request_list"></Approve>
    </el-dialog>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.key" :style="isMobile ? 'width: 230px !important;' : ''" placeholder="医院名称/任职机构"></el-input>
      </el-form-item>
      <!-- <el-form-item :style="isMobile ? 'width: 280px !important;' : ''" label="">
        <el-select :style="isMobile ? 'width: 280px !important;' : ''" v-model="filters.checkStatus" clearable placeholder="本月填报状态">
          <el-option label="待填报" :value="1"></el-option>
          <el-option label="已填报" :value="2"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <div v-if="isMobile" class="table_top_div">
      <cataractnnvmpListMobilehco :hco_if="hco_if" :tabel_list="tabel_list"></cataractnnvmpListMobilehco>
    </div>
    <!--列表-->
    <div v-else>
      <div v-if="SP_IF" style="margin-bottom: 5px">
        <div style="background-color: white; padding: 30px; border-radius: 10px">
          <Approve v-if="SP_IF" :SP_IF="SP_IF" @approve_submit="approve_submit" :ApproveList="tabel_list[0].approvaResultDto"></Approve>
        </div>
      </div>
      <div class="table_top_div" style="text-align: center" v-if="tabel_list_if">暂无数据</div>
      <div class="table_top_div" v-for="(item, indexitem) in tabel_list" style="margin-bottom: 5px">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 0 15px">
          <span style="margin-bottom: 5px; font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7; vertical-align: sub">
            {{ item.details[0].hospitalName }}
          </span>
          <el-tag style="vertical-align: middle" :type="item.isReportedThisWeek ? 'success' : 'danger'">
            {{ item.isReportedThisWeek ? '本月已填报' : '本月未填报' }}
          </el-tag>
        </div>

        <!-- <el-button v-if="item.approvaResultDto && !SP_IF" type="primary" style="margin-left: 20px" @click="open_approve(item.approvaResultDto)">
            查看审批状态
          </el-button> -->
        <div style="margin-bottom: 10px; padding-left: 15px">
          <el-form :model="item" :inline="true">
            <el-form-item label="DRG费用">
              <span slot="label">
                <span style="font-weight: bold">DRG费用</span>
              </span>
              <el-input v-model="item.drg" style="width: 200px; margin-right: 10px" placeholder="不含手术费，只是晶体费用"></el-input>
            </el-form-item>
            <el-form-item label="DIP费用">
              <span slot="label">
                <span style="font-weight: bold">DIP费用</span>
              </span>
              <el-input v-model="item.dip" style="width: 200px; margin-right: 10px" placeholder="不含手术费，只是晶体费用"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="margin-left: 10px" type="primary" v-preventReClick="3000" @click="save(item)">确认上报</el-button>
            </el-form-item>
            <!-- <el-form-item label="本年 Potential">
                <el-input disabled style="width: 200px" v-model="item.potential" placeholder="0"></el-input>
              </el-form-item> -->
          </el-form>
        </div>

        <!-- :cell-style="{ 'text-align': 'center' }" -->
        <el-table
          :cell-style="cellStyle"
          :border="true"
          cell-class-name="cell_class_name"
          max-height="100%"
          :data="item.details"
          :span-method="objectSpanMethod"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 8px 0 !important' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" width="80">
            <template slot-scope="scope">
              {{ indexitem + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="category" label="分类" width="120">
            <template slot-scope="scope">
              <span :style="scope.row.category == 'Total:' ? 'font-weight: bold' : ''">{{ scope.row.category }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productCategory" label="Category" width="150"></el-table-column>
          <el-table-column prop="product" label="Product" width>
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0">Product</span>
              <span @click="xdje_click" style="margin-left: 5px; cursor: pointer">
                <i :class="XDJE_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="hospitalName" label="医院" width="160"></el-table-column> -->
          <el-table-column v-if="XDJE_IF" prop="contractQuantity" label="国采签约量" width>
            <template style="background-color: red" slot-scope="scope">
              <el-input
                v-if="scope.row.category == 'Market'"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                v-model="scope.row.contractQuantity"
                class="border_none"
                placeholder="请填写"
              ></el-input>
              <span v-else :style="scope.row.category == 'Total:' ? 'font-weight: bold' : ''" class="border_none">
                {{ scope.row.contractQuantity }}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="XDJE_IF" prop="potential" label="全年分品类总手术量" width="180">
            <template v-if="scope.row.category == 'Market'" slot-scope="scope">
              <el-input
                onkeyup="value=value.replace(/[^\d]/g,'')"
                @blur="total_pnl(item, scope.row)"
                v-model="scope.row.potential"
                class="border_none"
                style="text-align: center"
                placeholder="请填写"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="XDJE_IF" prop="all_potential" label="全院总手术量" width>
            <template slot-scope="scope">{{ item.potential }}</template>
          </el-table-column>
          <!-- <el-table-column prop="drg" label="DRG费用(不含手术费只是费用)" width>
              <template slot-scope="scope">
                <el-input v-model="scope.row.drg" placeholder="请填写"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="drp" label="DIP费用(不含手术费，只是晶体费用)" width>
              <template slot-scope="scope">
                <el-input v-model="scope.row.drp" placeholder="请填写"></el-input>
              </template>
            </el-table-column> -->
          <el-table-column prop="totalSurgeries" label="YTD手术量（NVBP后）" width="180">
            <template slot-scope="scope">
              <span :style="scope.row.category == 'Total:' ? 'font-weight: bold' : ''">{{ scope.row.totalSurgeries }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="lastReportedSurgeries" label="上次填写手术量" width>
            </el-table-column> -->
          <el-table-column prop="lastWeekSurgeries" label="上月手术量" width>
            <template slot-scope="scope">
              <span
                v-if="scope.row.category == 'Total:' || scope.row.category == 'JJSV'"
                :style="scope.row.category == 'Total:' ? 'font-weight: bold' : ''"
                class="border_none"
              >
                {{ scope.row.lastWeekSurgeries }}
              </span>
              <el-input
                onkeyup="value=value.replace(/[^\d]/g,'')"
                @blur="total_sgs(item.details, scope.row)"
                v-else
                v-model="scope.row.lastWeekSurgeries"
                class="border_none"
                placeholder="请填写"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="150">
              <template scope="scope">
                <el-link type="primary" v-if="scope.row.IsDisable == true" @click="handleDisable(scope.row, false, '启用')">
                  <i class="el-icon-edit"></i>
                  启用&nbsp;|&nbsp;
                </el-link>
              </template>
            </el-table-column> -->
        </el-table>
        <div style="text-align: center; margin-top: 5px"></div>
      </div>
      <!--工具条-->
      <!-- <div class="toolbar_div">
          <el-col :span="24" class="toolbar">
            <el-pagination
              :background="true"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :pageNumber-size="50"
              :total="total"
              style="float: right"
            ></el-pagination>
          </el-col>
        </div> -->
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  cataractnnvmp_getlistv1,
  cataractnnvmp_submit,
  cataractnnvmp_approvalclaim,
  cataractnnvmp_approvalcancel,
  cataractnnvmp_exportdata,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { uploadfiles } from '@/uploadfiles'
import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'
import Approve from '../../components/Approve'
import cataractnnvmpListMobilehco from './mobile/cataractnnvmpListMobilehco'

export default {
  components: { Toolbar, quillEditor, Approve, cataractnnvmpListMobilehco },
  data() {
    return {
      hco_if: false,
      XDJE_IF: false,
      tabel_list_if: false,
      isMobile: false,
      dialogVisible_approve: false,
      SP_IF: '',
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
      cellErrors: {},
    }
  },
  methods: {
    xdje_click() {
      this.XDJE_IF = this.XDJE_IF ? false : true
    },
    total_pnl(scope, row) {
      if (row.category != 'Market') {
        return
      }
      let sun = 0
      scope.details.forEach((item) => {
        if (item.category == 'Market') {
          sun += Number(item.potential)
        }
      })
      scope.potential = sun
    },
    total_sgs(scope, row) {
      if (row.category != 'JJSV') {
        return
      }
      let sun = 0
      scope.forEach((item) => {
        if (item.category == 'JJSV') {
          sun += Number(item.lastWeekSurgeries)
        }
      })
      scope.find((item) => {
        if (item.category == 'Total:') {
          item.lastWeekSurgeries = sun
        }
      })
    },
    async ExportAccount() {
      let para = {}
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await cataractnnvmp_exportdata(para)
      uploadfiles(data, headers, this.loading)
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    async approve_submit(res) {
      if (res.CH_IF) {
        var { data } = await cataractnnvmp_approvalcancel(res)
      } else {
        var { data } = await cataractnnvmp_approvalclaim(res)
      }
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    // 记录有错误的单元格，定位对应的产品
    markErrorCells(details, products, products1, fieldName, hospitalCode) {
      // 初始化医院维度的错误信息存储
      if (!this.cellErrors[hospitalCode]) {
        this.cellErrors[hospitalCode] = {}
      }

      const allProducts = [...products, ...products1] // 合并两个产品组

      // 遍历所有产品
      allProducts.forEach((productKey) => {
        details.forEach((detail, index) => {
          if (detail.product === productKey) {
            // 如果该医院该行没有初始化错误对象，进行初始化
            if (!this.cellErrors[hospitalCode][index]) {
              this.cellErrors[hospitalCode][index] = {}
            }
            // 标记该字段为有错误
            this.cellErrors[hospitalCode][index][fieldName] = true
            console.log(`找到错误: ${hospitalCode} - 行: ${index}, 字段: ${fieldName}`)
          }
        })
      })

      console.log(this.cellErrors) // 输出调试信息，确保 hospitalCode 正确保存
    },

    // 计算产品的某一字段的合计值
    calculateProductSums(details, fieldName) {
      const productCategories = {
        JJSVDepthExtension: { products: ['ZXT00', 'ZXR00', 'ZFR00v'] },
        MarketDepthExtension: { products: ['景深延长(散+非散)', '三焦点(散+非散)'] },
        JJSVDualFocus: { products: ['ZMB00', 'ZMT00'] },
        MarketDualFocus: { products: ['双焦(散+非散)'] },
        JJSVSingleScattering: { products: ['ZCT00', 'ZCU00'] },
        MarketSingleScattering: { products: ['单焦散光'] },
        JJSVSingleNonScattering: { products: ['ICB00', 'DCB00', 'Others'] },
        MarketSingleNonScattering: { products: ['单焦非散'] },
      }

      const productSums = {}

      // 遍历定义的产品分类
      Object.keys(productCategories).forEach((key) => {
        const { products } = productCategories[key]
        // 计算某一字段的合计值
        productSums[key] = details
          .filter((detail) => products.includes(detail.product))
          .reduce((sum, detail) => sum + Number(detail[fieldName] || 0), 0)
      })

      return productSums
    },
    // 检查分组中是否有至少一个有效数字填写（包括0），如果没有则跳过校验
    checkAnyValidNumber(details, groupKey, fieldName) {
      const productCategories = {
        MarketDepthExtension: { products: ['景深延长(散+非散)', '三焦点(散+非散)'] },
        MarketDualFocus: { products: ['双焦(散+非散)'] },
        MarketSingleScattering: { products: ['单焦散光'] },
        MarketSingleNonScattering: { products: ['单焦非散'] },
      }

      // 获取当前分组的产品
      const products = productCategories[groupKey].products

      // 遍历分组中的产品，检查是否至少有一个有效数字（包括 0）
      const hasValidNumber = products.some((product) => {
        const productDetail = details.find((detail) => detail.product === product)
        const value = productDetail ? productDetail[fieldName] : undefined
        return value !== undefined && value !== null && value !== '' // 只要有一个有效数据就返回 true
      })

      return hasValidNumber
    },
    // 校验逻辑，只根据产品进行校验
    check(details) {
      this.cellErrors = {} // 清空之前的错误标记
      const zcnCode = details[0].zcnCode
      const productQuantitySums = this.calculateProductSums(details, 'contractQuantity')
      const productLastWeekSurgeriesSums = this.calculateProductSums(details, 'lastWeekSurgeries')
      console.log(productLastWeekSurgeriesSums)
      // 校验每一对产品
      if (this.checkAnyValidNumber(details, 'MarketDepthExtension', 'contractQuantity')) {
        if (productQuantitySums['MarketDepthExtension'] < productQuantitySums['JJSVDepthExtension']) {
          this.markErrorCells(details, ['景深延长(散+非散)', '三焦点(散+非散)'], ['ZXT00', 'ZXR00', 'ZFR00v', 'DFW00'], 'contractQuantity', zcnCode) // 标记有问题的产品
          return `Market国采签约量【景深延长(散+非散)】加【三焦点(散+非散)】值不能小于 JJSV 对应值。`
        }
      }
      if (this.checkAnyValidNumber(details, 'MarketDualFocus', 'contractQuantity')) {
        if (productQuantitySums['MarketDualFocus'] < productQuantitySums['JJSVDualFocus']) {
          this.markErrorCells(details, ['双焦(散+非散)'], ['ZMB00', 'ZMT00'], 'contractQuantity', zcnCode)
          return `Market国采签约量【双焦(散+非散)】值不能小于 JJSV 对应值。`
        }
      }
      if (this.checkAnyValidNumber(details, 'MarketSingleNonScattering', 'contractQuantity')) {
        if (productQuantitySums['MarketSingleNonScattering'] < productQuantitySums['JJSVSingleNonScattering']) {
          this.markErrorCells(details, ['单焦非散'], ['ICB00', 'DCB00', 'DIB00', 'Others', 'ZCB00'], 'contractQuantity', zcnCode)
          return `Market国采签约量【单焦非散】值不能小于 JJSV 对应值。`
        }
      }
      if (this.checkAnyValidNumber(details, 'MarketSingleScattering', 'contractQuantity')) {
        if (productQuantitySums['MarketSingleScattering'] < productQuantitySums['JJSVSingleScattering']) {
          this.markErrorCells(details, ['单焦散光'], ['ZCT00', 'ZCU00', 'DIU00'], 'contractQuantity', zcnCode)
          return `Market国采签约量【单焦散光】值不能小于 JJSV 对应值。`
        }
      }

      // 校验上月手术量
      if (productLastWeekSurgeriesSums['MarketDepthExtension'] < productLastWeekSurgeriesSums['JJSVDepthExtension']) {
        this.markErrorCells(details, ['景深延长(散+非散)', '三焦点(散+非散)'], ['ZXT00', 'ZXR00', 'ZFR00v'], 'lastWeekSurgeries', zcnCode)
        return `Market上月手术量【景深延长(散+非散)】加【三焦点(散+非散)】值不能小于 JJSV 对应值。`
      }
      if (productLastWeekSurgeriesSums['MarketDualFocus'] < productLastWeekSurgeriesSums['JJSVDualFocus']) {
        this.markErrorCells(details, ['双焦(散+非散)'], ['ZMB00', 'ZMT00'], 'lastWeekSurgeries', zcnCode)
        return `Market上月手术量【双焦(散+非散)】值不能小于 JJSV 对应值。`
      }
      if (productLastWeekSurgeriesSums['MarketSingleNonScattering'] < productLastWeekSurgeriesSums['JJSVSingleNonScattering']) {
        this.markErrorCells(details, ['单焦非散'], ['ICB00', 'DCB00', 'Others'], 'lastWeekSurgeries', zcnCode)
        return `Market上月手术量【单焦非散】值不能小于 JJSV 对应值。`
      }
      if (productLastWeekSurgeriesSums['MarketSingleScattering'] < productLastWeekSurgeriesSums['JJSVSingleScattering']) {
        this.markErrorCells(details, ['单焦散光'], ['ZCT00', 'ZCU00'], 'lastWeekSurgeries', zcnCode)
        return `Market上月手术量【单焦散光】值不能小于 JJSV 对应值。`
      }

      // 校验通过，返回空字符串
      return ''
    },
    async save(res) {
      // 执行校验
      const checkMessage = this.check(res.details)
      if (checkMessage) {
        this.$message.error(checkMessage) // 如果校验失败，显示错误提示
        return
      }
      //   res.dip = res.details[0].dip
      //   res.drg = res.details[0].drg
      //   res.potential = res.details[0].all_potential
      console.log(res)
      const { data } = await cataractnnvmp_submit(res)
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      const columnName = column.property // 获取列的属性名（如 contractQuantity、lastWeekSurgeries 等）
      const hospitalCode = row.zcnCode // 获取当前行的医院编码
      const category = row.category // 获取当前行的医院编码

      // 确保 cellErrors 以及该医院的错误数据存在
      if (this.cellErrors[hospitalCode] && this.cellErrors[hospitalCode][rowIndex] && this.cellErrors[hospitalCode][rowIndex][columnName]) {
        return { backgroundColor: '#eca5a5' } // 红色背景，表示有错误
      }
      if (columnName == 'totalSurgeries' || columnName == 'all_potential' || columnName == 'lastWeekSurgeries') {
        return {
          'background-color': '#f6f9ff',
        }
      }
      if ((columnName == 'potential' || columnName == 'contractQuantity') && (category == 'JJSV' || category == 'Total:')) {
        return {
          'background-color': '#f6f9ff',
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const columnName = column.property // 获取列的属性名（如 contractQuantity、lastWeekSurgeries 等）
      const category = row.category // 获取当前行的医院编码
      if (columnName == 'all_potential') {
        if (rowIndex % 20 === 0) {
          return {
            rowspan: 20,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
      if (columnName == 'potential' && rowIndex < 11) {
        if (rowIndex % 14 === 0) {
          return {
            rowspan: 14,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
      if (columnIndex === 0) {
        if (rowIndex % 20 === 0) {
          return {
            rowspan: 20,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
    },
    // 合并数据
    mergeData(data) {
      //   let spanArr = []
      //   let concatSpanArr = []
      let merge = {}
      data.map((item, index) => {
        merge = {
          all_potential: item.potential,
          dip: item.dip,
          drg: item.drg,
        }
        item.details.map((item2, index2) => {
          item2 = { ...item2, ...merge }
          item.details[index2] = item2
        })
      })
      return data
      //   console.log(data)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageNumber = this.pageNumber
      console.log(para)
      // return
      //   let para = {
      //     pageNumber: this.pageNumber,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      cataractnnvmp_getlistv1(para).then((res) => {
        this.total = res.data.data.dataCount
        if (res.data.length == 0) {
          this.tabel_list_if = true
        }
        // this.tabel_list = this.mergeData(res.data.data.data)
        this.tabel_list = res.data.data
        this.listLoading = false
        // this.SP_IF = this.$route.query.status
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    if (this.$route.name == '医院基础信息') {
    }
    console.log(this.$route)
  },
}
</script>

<style scoped></style>
